// extracted by mini-css-extract-plugin
export default {"screenSm":"992px","clementine":"#ef6400","topLinks":"styles_topLinks__BNUzc list-reset_listReset__oUnYG","button":"styles_button__OLdlF","link":"styles_link__SnWX1"};